import React, {useState} from 'react';
import { FormPageFieldComponentDefaultProps } from 'types/formPage';
import { withFormikFormControl } from '../FormikFormControl';
import BaseSelect from "../SelectOptions/BaseSelect";

export const MultiSelect = (props: FormPageFieldComponentDefaultProps) => {
  return <BaseSelect multiple={true} {...props}/>
};

export const MultiSelectFormik = withFormikFormControl()(MultiSelect);

export default MultiSelectFormik;
